var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueSignaturePad',{ref:"signaturePad",attrs:{"id":"signature","width":"100%","height":"150px","options":{
      onBegin: () => {
        _vm.$refs.signaturePad.resizeCanvas();
      },
      onEnd: _vm.onEnd,
    }}}),_c('button',{staticClass:"clear",on:{"click":_vm.clear}},[_vm._v("Clear")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }